/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Dayjs } from 'dayjs';
import { CommonUtils } from '../../tool/common-utils';

export class CalendarUtils {
  public static compareDMY(date1: Dayjs, date2: Dayjs): boolean {
    return (
      date1.get('month') === date2.get('month') &&
      date1.get('date') === date2.get('date') &&
      date1.get('year') === date2.get('year')
    );
  }

  public static getWeekCountOfMonth(date: Dayjs): number {
    return CommonUtils.getWeekCountOfMonth(date.toDate());
  }

  public static getMonthOffset(date: Dayjs): number {
    let m = date.clone().startOf('month').startOf('week');
    let count = 0;
    while (m.month() < date.month()) {
      m = m.add(1, 'day');
      ++count;
    }
    return count;
  }
}
